import { render, staticRenderFns } from "./PrChartChromatogramMultiple.vue?vue&type=template&id=5107bf0c&scoped=true&"
import script from "./PrChartChromatogramMultiple.vue?vue&type=script&lang=js&"
export * from "./PrChartChromatogramMultiple.vue?vue&type=script&lang=js&"
import style0 from "./PrChartChromatogramMultiple.vue?vue&type=style&index=0&id=5107bf0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107bf0c",
  null
  
)

export default component.exports